import { faBus, faTrain } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Cube, LocationDTO } from "../../state/types";
import { Section } from "./Section";
import { Bevolking } from "./surroundings/Bevolking";
import { Hinder } from "./surroundings/Hinder";
import { Leefbaarheid } from "./surroundings/Leefbaarheid";
import { Voorzieningen } from "./surroundings/Voorzieningen";
import { A, Info, KV, Tooltip } from "./util";

const description = (
  <>
    De leefomgeving. Gebaseerd op{" "}
    <A href="https://www.atlasleefomgeving.nl/thema/prettig-wonen">Atlas leefomgeving</A>.{" "}
    Voorzieningen afgeleid van <A href="https://opendata.cbs.nl/#/CBS/nl/">CBS</A>. De
    OV-bereikbaarheid is gebaseerd op locaties van{" "}
    <A href="https://www.ns.nl/reisinformatie">stations</A> en{" "}
    <A href="https://www.openov.nl/">bushaltes</A>, en CBS gegevens. Leefbaarheid is gebaseeerd op{" "}
    <A href="https://www.leefbaarometer.nl/">de Leefbaarometer</A>. Geluidshinder via{" "}
    <A href="https://www.rivm.nl/ggd-richtlijn-mmk-omgevingsgeluid/gezondheidseffecten-geluid/geluidhinder">
      RIVM
    </A>
    .
  </>
);

const Location = ({ icon, location }: { icon: any; location: LocationDTO }) => (
  <Tooltip className="ml-auto hover:text-dark mr-2" content={location.description}>
    <FontAwesomeIcon icon={icon} fill="currentColor" aria-hidden="true" />{" "}
    {location.distance.toFixed()}m{" "}
  </Tooltip>
);

const Locations = ({ locations }: { locations: LocationDTO[] }) => {
  if (!locations?.length) return null;
  const data = locations.reduce((memo, a) => {
    memo[a.type] = a;
    return memo;
  }, {});
  return (
    <KV k="OV bereikbaarheid">
      <Location icon={faBus} location={data["OV"]} />
      <Location icon={faTrain} location={data["TREIN"]} />
    </KV>
  );
};

/*
https://allecijfers.nl/wijk/oosterparkwijk-groningen/
https://kadastralekaart.com/wijken/oosterparkwijk-WK001404
 */
export const SectionSurroundings = ({ field }: { field: Cube }) => {
  const stats = field.stats;
  return (
    <Section name="surroundings" description={description}>
      <Info as="dl">
        <Bevolking stats={stats.neighbourhood} />
        <Voorzieningen stats={stats.proximity} center={field.center} />
        <Locations locations={field.locations} />
        <Leefbaarheid stats={stats.livability} />
        <Hinder stats={stats.noise} />
        {/*<KV k="Risico's">Risicokaart</KV>*/}
      </Info>
    </Section>
  );
};
